import { render, staticRenderFns } from "./AidfCadastro.vue?vue&type=template&id=525556f5&scoped=true&"
import script from "./AidfCadastro.vue?vue&type=script&lang=js&"
export * from "./AidfCadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525556f5",
  null
  
)

export default component.exports